import React, { useContext } from 'react';
import { Typography, makeStyles, Theme } from '@material-ui/core';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { FontIcon } from '@moderepo/mode-app-components';
import { useParams } from 'react-router-dom';
import { useRitzTranslation } from '../../utils/customHooks';


const useStyle = makeStyles((theme: Theme) => {
    return {
        root: {
            textAlign: 'center',
            padding  : theme.spacing(4),
            position : 'absolute',
            height   : '100%',
            width    : '100%',
        },

        icon: {
            fontSize    : '100px',
            marginBottom: theme.spacing(2),
            color       : theme.palette.error.main,
        },

        title: {
            paddingBottom: theme.spacing(2),
        },

        subtitle: {

        },
    };
}, { name: 'NotAuthorizedPage' });


export const RCNotAuthorized: React.FC = () => {
    const params = useParams();
    const projectId = params.projectId ? Number(params.projectId) : undefined;
    const { state:dataState } = useContext(ritzDataContext);
    const project = projectId ? selectProjectById(dataState, projectId) : undefined;
    const { trans } = useRitzTranslation(project);
    const classes = useStyle();

    return (
        <div className={classes.root}>
            <FontIcon className={classes.icon} iconName="modes-icon robot-solid" />
            <Typography variant="h3" className={classes.title}>{trans('unauthorized.title')}</Typography>
            <Typography variant="h6" className={classes.title}>{trans('unauthorized.message')}</Typography>
        </div>
    );
};
